import React from 'react';
import { useView } from '../../contexts/ViewContext';
import PhotoGallery from './PhotoGallery';
import PhotoUploader from './PhotoUploader';

const PhotoGalleryWrapper: React.FC = () => {
  const { view, setView } = useView();

  if (view.subPage === 'new' && typeof view.id === 'string') {
    return <PhotoUploader folderId={view.id} setView={setView} />;
  }

  if (view.subPage === 'folder' && typeof view.id === 'string') {
    return <PhotoGallery setView={setView} initialFolderId={view.id} />;
  }

  return <PhotoGallery setView={setView} />;
};

export default PhotoGalleryWrapper;
